import { Navigate } from 'react-router'
import { createBrowserRouter } from 'react-router-dom'
import { Dashboard, ForgotPassword, Login, ResetPassword } from '~/pages'
import actions from './actions'
import { ActionGuard, BSHApp, RequireAuth, RequireGuest } from './components'
import { PageBoundary, RouteBoundary } from './components/ErrorBoundry'
import models from './models'

const commonBaseRouteProps = {
  errorElement: <PageBoundary />,
}

const routes = [
  {
    path: '/',
    element: <BSHApp />,
    errorElement: <RouteBoundary />,
    children: [
      {
        ...commonBaseRouteProps,
        path: '',
        element: (
          <RequireAuth>
            <Navigate to="/bosch" />
          </RequireAuth>
        ),
      },
      {
        ...commonBaseRouteProps,
        path: 'login',
        element: (
          <RequireGuest>
            <Login />
          </RequireGuest>
        ),
      },
      {
        ...commonBaseRouteProps,
        path: 'forgot-password',
        element: (
          <RequireGuest>
            <ForgotPassword />
          </RequireGuest>
        ),
      },
      {
        ...commonBaseRouteProps,
        path: 'reset-password/:token',
        element: (
          <RequireGuest>
            <ResetPassword />
          </RequireGuest>
        ),
      },
      {
        ...commonBaseRouteProps,
        path: ':brand_path',
        children: [
          {
            ...commonBaseRouteProps,
            path: '',
            element: (
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            ),
          },
          ...actions.map((action) => ({
            ...commonBaseRouteProps,
            path: action.path,
            element: (
              <RequireAuth>
                <ActionGuard />
              </RequireAuth>
            ),
            children: models.map((model) => {
              return {
                ...commonBaseRouteProps,
                // path: ':action/:model?/:id?/:child_model?/:child_id?',
                path: `${model}/:id`,
                element: (
                  <RequireAuth>
                    <ActionGuard />
                  </RequireAuth>
                ),
              }
            }),
          })),
        ],
      },
    ],
    // indexRoute: { components: { content: Dashboard } },
    // childRoutes: [],
    // getChildRoutes: (nextState, cb, t) => {
    //   var location = nextState.location
    //   const hash = nextState.location.hash.replace(/^#/, '')
    //   var is_import = isImport(location)
    //   var url = location.pathname.replace(/^\/|\/$/, '')
    //   var parts = url.split('/')
    //   var brand = getBrand(location)
    //   var action = getAction(location)
    //   var route,
    //     level = parts.length
    //   if (brand) {
    //     parts.shift()
    //     route = {
    //       path: '/:brand',
    //     }
    //     if (action) {
    //       parts.shift()
    //       route.path += '/:action'
    //       route.components = { action: action }
    //       if (parts.length == 0) {
    //         let content = {
    //           /*               import: Import,
    //           specs: TreeAsList,
    //           xml: TreeAsList,
    //           pictures: TreeAsList,
    //           promo: PromotionsList,
    //           upload: Upload, */
    //         }
    //         route.components.content = content[action] || NotFound
    //       } else if (
    //         parts.length >= 2 &&
    //         (parts[0] == 'category' || parts[0] == 'promotion')
    //       ) {
    //         const promoedit = parts[0] == 'promotion'
    //         let category = null,
    //           product = null
    //         if (!promoedit) {
    //           parts.shift()
    //           route.path += '/category/:category'
    //           category = categories[parts.shift()]
    //         }
    //         if (parts.length >= 2 && parts[0] == 'product') {
    //           parts.shift()
    //           route.path += '/product/:product'
    //           product = products[parts.shift()]
    //         }
    //         if (promoedit || (parts.length >= 2 && parts[0] == 'promotion')) {
    //           parts.shift()
    //           route.path += '/promotion/:promotion'
    //           action = 'promoedit'
    //         }
    //         if (hash.match(/^matrix\/\d+$/)) {
    //           action = 'matrix'
    //         }
    //         let content =
    //           category && category.categories
    //             ? {
    //                 /*                     import: TreeAsList,
    //                 specs: TreeAsList,
    //                 xml: TreeAsList,
    //                 html: TreeAsList,
    //                 euro: TreeAsList,
    //                 mex: TreeAsList,
    //                 pictures: TreeAsList,
    //                 promo: PromotionsList,
    //                 promoedit: PromotionEdit,
    //                 export: Export, */
    //               }
    //             : {
    //                 /*                     import: ImportDetails,
    //                 specs: CategoryDetails,
    //                 xml: product ? ProductXML : TreeAsList,
    //                 html: ParagraphsEditor,
    //                 euro: EuroEditor,
    //                 mex: MExEditor,
    //                 pictures: product ? ProductPictures : TreeAsList,
    //                 promo: PromotionsList,
    //                 promoedit: PromotionEdit,
    //                 export: Export,
    //                 matrix: PropertyMatrix, */
    //               }
    //         route.components.content = content[action] || NotFound
    //       } else if (
    //         action == 'import' &&
    //         parts.length &&
    //         parts[0] == 'dictionary'
    //       ) {
    //         route.path += '/dictionary'
    //         /*             route.components.content = Dictionary */
    //       } else {
    //         route = null
    //       }
    //     } else {
    //       route.components = { content: Dashboard }
    //     }
    //   }
    //   if (!route)
    //     route = {
    //       path: '*',
    //       components: { content: NotFound },
    //     }
    //   // console.log(route && route.components && route.components.content ? route.components.content.displayName : undefined)
    //   cb(null, [route])
    // },
  },
  // {
  //   ...commonBaseRouteProps,
  //   path: 'login',
  //   element: <Login />,
  // },
]

// eslint-disable-next-line react-refresh/only-export-components
export default createBrowserRouter(routes)
